import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

// Our Components
import Dropdown from 'components/Dropdown/Dropdown';

// Our PropTypes
import CommonPropTypes from 'shared/prop-types';

// CONSTANTS
const LOAN_TYPES = ['Fixed', 'Variable'];

function LoanTypeDropdown({
	dropDownSX,
	dropDownLabelSX,
	gridColumns,
	sx,
	loanType,
	setLoanType,
	tabIndex,
	required
}) {
	return (
		<Grid item xs={gridColumns} sx={{ marginBottom: 4, ...sx }}>
			<Dropdown
				items={LOAN_TYPES}
				label="Loan Type"
				labelSx={dropDownLabelSX}
				onChange={setLoanType}
				selected={loanType}
				sx={dropDownSX}
				variant="outlined"
				required={required}
			/>
		</Grid>
	);
}

LoanTypeDropdown.propTypes = {
	dropDownSX: CommonPropTypes.sx,
	dropDownLabelSX: CommonPropTypes.sx,
	gridColumns: PropTypes.number,
	loanType: PropTypes.string.isRequired,
	setLoanType: PropTypes.func.isRequired,
	sx: CommonPropTypes.sx,
	required: PropTypes.bool
};

LoanTypeDropdown.defaultProps = {
	dropDownLabelSX: {},
	dropDownSX: {},
	gridColumns: 5,
	sx: {},
	required: false
};

export default LoanTypeDropdown;
